import { createStore, applyMiddleware, compose } from 'redux';
import promiseMiddleware from 'redux-thunk';

import rootReducer from '../reducer';


const middlewares = [promiseMiddleware, require('redux-immutable-state-invariant')()];


const enhancer = compose(applyMiddleware(...middlewares));

export default function configureStore(initialState) {
  const store = createStore(rootReducer, initialState, enhancer);

  if (module.hot) {
    module.hot.accept('../reducer', () => {
      const nextReducer = require('../reducer').default;

      store.replaceReducer(nextReducer);
    });
  }

  return store;
}
